<template>
  <div>
    <div class="tip">
      <div>移动端正在开发中...</div>
      <div>如有需要请先移步PC端,</div>
      <div>给您带来的不便，尽请谅解。</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style scoped lang='sass'>

.tip
  width: 70%
  margin: 0 auto
  height: 100vh
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
</style>
